const styles = {
  mainContainer: {
    flex: 6,
    // padding: "0 1rem",
  },
  main: {
    flex: 4,
    padding: "1 1rem",
  },
  rightAside: {
    flex: 2,
    paddingRight: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
  },
  cardContainer: {
    display: "flex",
    gap: "0px",
    marginBottom: "0rem",
    overflowX: "auto",
  },
  appointment: {
    padding: "0 1rem 0.5rem",
  },
  tableHeadCell: {
    padding: ".5rem 1rem",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
  appointmentTableHeadCell: {
    padding: ".5rem 1rem",
    color: "#000000",
    fontWeight: 600,
    background: "#E3F0FF",
    fontSize: "14px",
  },

  awardsTableHeadCell: {
    padding: ".5rem 1rem",
    color: "#000000",
    fontWeight: 600,
    background: "#ECE2FF",
    fontSize: "14px",
  },

  gohonzonTableHeadCell: {
    padding: "2px",
    color: "#000000",
    fontWeight: 600,
    background: "#E3F0FF",
    fontSize: "14px",
  },

  tableRowCell: {
    borderBottom: "1px solid #BFCFE1",
  },
  status: {
    backgroundColor: "#E8FFDB",
    border: "1px solid #1C9C29",
    borderRadius: 12,
    padding: "2px 12px",
  },
  attandence: {
    display: "flex",
    gap: "1rem",
    padding: "0 1rem",
    flex: 1,
  },
  attandenceTable: {
    flex: 1,
  },
  attendanceTableHeading: {
    paddingBottom: "0.5rem",
  },
  listContainer: {
    padding: "0 1rem",
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    background: "#FFEFEF",
    margin: "8px 0px 8px 0px",
    padding: "5px",
  },

  remark: {
    display: "flex",
    flexGrow: 1,
    background: "#E8EDF4",
    margin: "0px 8px 8px 8px",
    padding: "4px 8px",
    borderRadius: "8px",
    boxShadow: "4px 4px 8px 0px rgba(0, 0, 0, 0.20)",
  },
  modal: {
    minHeight: 400,
    maxHeight: "95%",
    width: "55%",
    overflowY: "scroll",
  },
  inputStyle: {
    height: 191,
    minWidth: "330",
    maxWidth: "400",
    // border: "1px solid #707070",
    borderRadius: "5px",
  },
  lastContainer: {
    padding: "0 1rem",
    width: "100%",
    display: "flex",
    gap: "1rem",
    flex: 1,
  },

  remarksStyle: {
    color: "#000000",
    fontSize: " 14px",
    maxWidth: "250px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  hoverStyle: {
    padding: "4px 8px",
    position: "absolute",
    left: "0px",
    top: "70%",
    transform: "translateX(-50%)",
    color: "white",
    fontSize: "14px",
    borderRadius: "4px",
    zIndex: 2,
    backgroundColor: "#2C2C2C",
  },

  flagSvgStyle: {
    cursor: "pointer",
    position: "relative",
    display: "inline-block",
  },
};

export default styles;
